import React from 'react'

import { FieldArray } from 'formik'

import useSingleton from '../../../business-components/useSingleton/useSingleton'

import HELPTEXT from '../../../business-const/HelpText/HelpText'

import LABEL from '../../../business-const/Label/Label'

import {
    DivForm,
} from '../../../business-components/Div/Div'

import {
    GridContainer,
    GridItem4sm6xs12,
} from '../../../business-components/Grid/Grid'

import {
    PanelRadioGroup
} from '../../../business-components/RadioGroup/RadioGroup'

import {
    pesquisaList
} from '../../../business-rules/List/ListService'

import familiaresList from '../../../business-rules/List/familiaresList'

import tipoReceitaMensalList from '../../../business-rules/List/tipoReceitaMensalList'

import tipoMultiploSalarioSeguroVidaEmGrupo from '../../../business-rules/List/tipoMultiploSalarioSeguroVidaEmGrupo'

import {
    ButtonIncluirLinha
} from '../../../business-components/Button/Button'

import {
    obtemPage,
    salvaPage,
} from '../cliente-form/ClienteService'

import {
    TablePaginationPadraoReceitaMensal,
    rowPertentePageReceitaMensal,
    setPageInclusaoReceitaMensal,
} from './GarantiasCompReceitaMensal'

import {
    incrementaContReceitaMensal,
    processaRegistrosDefaultIniciaisReceitaMensal,
    processaValoresDefaultIniciaisReceitaMensal,
    calculaTotaisReceitaMensal,
} from './GarantiasServiceReceitaMensal'

import GarantiasFormReceitaMensalItem from './GarantiasFormReceitaMensalItem'



const GarantiasFormReceitaMensal = ({ values, handleChange, setFieldValue }) => {

    calculaTotaisReceitaMensal(values)
 
    useSingleton(async () => {

        values.pageReceitaMensal = obtemPage(values.pageReceitaMensalList, Number.parseInt(values.familiarReceitaMensal))
    })

    salvaPage(values.pageReceitaMensal, values.pageReceitaMensalList, Number.parseInt(values.familiarReceitaMensal))
    
    let indAux = 0

    values.receitaMensalPagination = 
        values.receitaMensal
            ?
                values.receitaMensal.filter(item => item.familiar === Number.parseInt(values.familiarReceitaMensal) &&
                    !item.idReceitaMensal && !item.idPatrimonioImobilizado)
            :
                []



    return (
        <>
            <PanelRadioGroup
                name="familiarReceitaMensal"
                value={Number.parseInt(values.familiarReceitaMensal) || ''}
                onChange={(e) => {
                    values.pageReceitaMensal = obtemPage(values.pageReceitaMensalList, Number.parseInt(e.target.value))
                    handleChange(e)
                }}
                list={values.totalReceitaMensal}
                onBlur={
                    processaRegistrosDefaultIniciaisReceitaMensal(values,
                        Number.parseInt(values.familiarReceitaMensal))
                }
                helpText={HELPTEXT.receitaMensalPanelRadioGroup}
            />
               
            <FieldArray name="receitaMensal">
                {(arrayHelpers) => (
                    <DivForm>
                        <GridContainer>
                            {values.receitaMensal?.map((item, ind) => {

                                let tipoReceitaMensalSelecionada = pesquisaList(tipoReceitaMensalList, 
                                    item.tipoReceitaMensal)
                                    
                                processaValoresDefaultIniciaisReceitaMensal(values, item, ind, tipoReceitaMensalSelecionada)

                                let tipoMultiploSalarioSeguroVidaEmGrupoSelecionado =
                                    pesquisaList(tipoMultiploSalarioSeguroVidaEmGrupo,
                                        item.tipoMultiploSalarioSeguroVidaEmGrupo)

                                return item.familiar === Number.parseInt(values.familiarReceitaMensal) && !item.idReceitaMensal &&
                                !item.idPatrimonioImobilizado &&
                                rowPertentePageReceitaMensal(values, indAux++) ? (
                                    <GridItem4sm6xs12
                                        key={ind}
                                    >
                                        <GarantiasFormReceitaMensalItem
                                            values={values}
                                            handleChange={handleChange}
                                            setFieldValue={setFieldValue}
                                            arrayHelpers={arrayHelpers}
                                            tipoReceitaMensalSelecionada={
                                                tipoReceitaMensalSelecionada
                                            }
                                            tipoMultiploSalarioSeguroVidaEmGrupoSelecionado={
                                                tipoMultiploSalarioSeguroVidaEmGrupoSelecionado
                                            }
                                            item={item}
                                            ind={ind}
                                            simplificado={false}
                                        />
                                    </GridItem4sm6xs12>
                                )
                                :
                                (
                                   ''
                                )
                            })}
                        </GridContainer>

                        <TablePaginationPadraoReceitaMensal
                            values={values}
                            setFieldValue={setFieldValue}
                        />

                        <ButtonIncluirLinha
                            label={LABEL.buttonIncluirReceitaMensal} 
                            disabled={familiaresList(values).length === 0 || !values.familiarReceitaMensal ? true : false}
                            onClick={() =>
                                {
                                    incrementaContReceitaMensal(values)
                                    arrayHelpers.push({
                                        id: values.contReceitaMensal,
                                        familiar: Number.parseInt(values.familiarReceitaMensal)
                                    })
                                    setPageInclusaoReceitaMensal(values, setFieldValue)
                                }
                            }
                        />
                    </DivForm>
                )}
            </FieldArray>
        </>
    )
}

export default GarantiasFormReceitaMensal